import { registerBlockType } from '@wordpress/blocks';
import { PanelBody, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import React from 'react';
import { createRoot } from 'react-dom/client';
import EventCalendar from './react-calendar-wrapper';


// Function to render the calendar
window.renderOecCalendar = (selector) => {
    const container = document.querySelector(selector);
    if (container) {
        const root = createRoot(container);
        root.render(<EventCalendar />);
    }
};

// Register the block
registerBlockType('orc2/oec-calendar', {
    title: 'Events Calendar',
    icon: 'calendar',
    category: 'widgets',
    keywords: ['Calendar', 'React'],
    attributes: {
        calendarHeight: {
            type: 'string',
            default: '700px',
        },
        calendarWidth: {
            type: 'string',
            default: '100%',
        },
    },
    edit: (props) => {
        const { attributes: { calendarHeight, calendarWidth }, setAttributes } = props;
        const blockProps = useBlockProps();
        return (
            <>
                <InspectorControls>
                    <PanelBody title="Calendar Settings">
                        <TextControl
                            label="Calendar Height"
                            value={calendarHeight}
                            onChange={(value) => setAttributes({ calendarHeight: value })}
                        />
                        <TextControl
                            label="Calendar Width"
                            value={calendarWidth}
                            onChange={(value) => setAttributes({ calendarWidth: value })}
                        />
                    </PanelBody>
                </InspectorControls>
                <div className="organon-events-calendar" {...blockProps} style={{ height: calendarHeight, width: calendarWidth }}>
                    <EventCalendar />
                </div>
            </>
        );
    },
    save: () => {
        return null;
    },
});